module.exports = __webpack_public_path__ + "static/media/db18a309338006fe86a38aa8dc7147c5.d1fa0b84.png";